import React from "react";
import { useContext, useEffect, useState } from "react";
import { OrderContext } from "../../OrderContext.tsx";
import { getVariation } from "../../../../../misc/helpers.ts";
import dayjs, { ManipulateType } from "dayjs";
import { useTranslation } from "react-i18next";

function ContractTypeText({ updateMinDate, updateMaxDate, all }: { updateMinDate: (date: string) => void, updateMaxDate: (date: string) => void, all?: boolean }) {
  const { formValues, products } = useContext(OrderContext);
  const { t } = useTranslation();

  const [selectedProduct] = useState(getVariation({ products, contractTemplateId: formValues['product'] }));
  const [minDateText, setMinDateText] = useState('5 vrk');
  const [maxDateText, setMaxDateText] = useState('3 kk');

    useEffect(() => {
      let minValue = 5;
      let minUnit = 'day';
      if (formValues['contract-type'] === 'New') {
        minValue = 18;
      }

      const productMinStartDateDiffDays = selectedProduct?.min_start_date ? dayjs(selectedProduct.min_start_date).diff(dayjs(), 'day') : 0;
      const biggerValue = Math.max(minValue, productMinStartDateDiffDays);
      updateMinDate(dayjs().add(biggerValue, minUnit as ManipulateType).format('YYYY-MM-DD'));
      setMinDateText(biggerValue + t('common.day'));

      if (selectedProduct && selectedProduct.max_start_date) {
        const maxDate = dayjs(selectedProduct.max_start_date).format('YYYY-MM-DD');
        updateMaxDate(maxDate);
        setMaxDateText(dayjs(maxDate).diff(dayjs(), 'day') + t('common.day'));
      } else {
        let maxTimeDelta = 6;
        if (selectedProduct && selectedProduct.max_start_months?.label) {
          maxTimeDelta = parseInt(selectedProduct.max_start_months.label.replace(' kk', ''));
        }
        updateMaxDate(dayjs().add(maxTimeDelta, 'month').format('YYYY-MM-DD'));
        setMaxDateText(maxTimeDelta + t('common.month'));
      }
    }, [formValues['contract-type']]);

    return (
      <div>
        {(all || formValues['contract-type'] === 'MoveIn') && <p>{all && <b>{t('contractTypes.moveTitle')}</b>} {t('contractTypes.moveText', { minDateText, maxDateText })} </p>}
        {(all || formValues['contract-type'] === 'New') && <p>{all && <b>{t('contractTypes.newTitle')}</b>} {t('contractTypes.newText', { minDateText, maxDateText })}</p>}
        {(all || formValues['contract-type'] === 'ProductChange') && <div>
          <p>{all && <b>{t('contractTypes.changeTitle')}</b>} {t('contractTypes.changeText1')}</p>
          <ul>
            <li>{t('contractTypes.changeText2', { minDateText })} </li>
            <li>{t('contractTypes.changeText3', { maxDateText })}</li>
          </ul>
        </div>}
      </div>
    )

}

export default ContractTypeText;
